let Complex = require('complex.js');


export function findQuarticRoots(a, b, c, d, e) {
    //https://en.wikipedia.org/wiki/Quartic_function
    const D0 = Complex(c * c - 3 * b * d + 12 * a * e);
    const D1 = Complex(2 * c * c * c - 9 * b * c * d + 27 * b * b * e + 27 * a * d * d - 72 * a * c * e);
    const p = Complex((8 * a * c - 3 * b * b) / (8 * a * a));
    const q = Complex((b * b * b - 4 * a * b * c + 8 * a * a * d) / (8 * a * a * a));

    const Q = Complex(Complex(D1*D1 - 4*D0*D0*D0).sqrt().add(D1).div(2)).pow(1.0 / 3.0);
    const S = Complex(Complex(Complex(-2/3*p)).add(Complex(1/(3*a)).mul(Complex(Q).add(Complex(D0).div(Q))))).sqrt().div(2);

    const u = Complex(((Complex(-4).mul(Complex(S).pow(2))).add(Complex(-2).mul(p))).add(Complex(q).div(S))).sqrt().div(2);
    const v = Complex(((Complex(-4).mul(Complex(S).pow(2))).add(Complex(-2).mul(p))).sub(Complex(q).div(S))).sqrt().div(2);

    const x1 = Complex(-b/(4*a)).sub(S).add(u);
    const x2 = Complex(-b/(4*a)).sub(S).sub(u);
    const x3 = Complex(-b/(4*a)).add(S).add(v);
    const x4 = Complex(-b/(4*a)).add(S).sub(v);

    let roots = [x1, x2, x3, x4]
    let realRoots = []
    for (let i = 0; i < roots.length; i++) {
        if (Math.abs(roots[i].im)<0.000001) {
            roots[i] = roots[i].re
        }
    }
    for (let i = 0; i < roots.length; i++) {
        if (typeof roots[i] == 'number') {
            realRoots.push(roots[i])
        }
    }   

    return realRoots;
}


// WEBPACK FOOTER //
// ./scripts/components/quartic.js